import React from "react";
import { Check } from "lucide-react";

const rows = [
    {
        task: "Sending files",
        old: "Email attachments, USB drives, WeTransfer links",
        new: "Drag & drop directly to the shop's dashboard",
    },
    {
        task: "Finding a shop",
        old: "Google, call around, ask friends, drive there",
        new: "Browse nearby shops with reviews and services",
    },
    {
        task: "Print specs",
        old: "Phone calls, back-and-forth emails, in-person visits",
        new: "Select options in a clean interface before sending",
    },
    {
        task: "Tracking orders",
        old: `"Did you get my email?" calls`,
        new: "Real-time status in the shop's dashboard",
    },
    {
        task: "In-store uploads",
        old: "Bring a USB or Bluetooth transfer",
        new: "Scan QR code, upload from your phone",
    },
    {
        task: "Finding supplies",
        old: "Cold calls, trade directories, word of mouth",
        new: "Browse verified suppliers on the marketplace",
    },
];

const WhySignetPrint = () => {
    return (
        <section className="bg-[#f8f8fa]">
            <div className="max-w-[1200px] mx-auto px-[16px] md:px-[40px] py-[56px] md:py-[80px]">

                {/* Header */}
                <div className="text-center mb-[48px]">
                    <p className="font-semibold text-[13px] text-[#ff5323] tracking-[0.5px] uppercase mb-[8px]">
                        Why SignetPrint
                    </p>
                    <h2 className="font-semibold text-[28px] md:text-[36px] text-[#212326] tracking-[-0.5px]">
                        The old way vs. the SignetPrint way
                    </h2>
                </div>

                {/* Table */}
                <div className="bg-white rounded-[20px] border border-[#e4e5e7] overflow-hidden">

                    {/* Header row */}
                    <div className="grid grid-cols-3 border-b border-[#e4e5e7]">
                        <div className="p-[16px] md:p-[20px]">
                            <p className="font-semibold text-[13px] text-[#9298a0]">Task</p>
                        </div>
                        <div className="p-[16px] md:p-[20px] bg-[#fafafa] border-x border-[#e4e5e7]">
                            <p className="font-semibold text-[13px] text-[#9298a0]">The old way</p>
                        </div>
                        <div className="p-[16px] md:p-[20px] bg-[#fff8f5]">
                            <p className="font-semibold text-[13px] text-[#ff5323]">SignetPrint</p>
                        </div>
                    </div>

                    {/* Rows */}
                    {rows.map((item, idx) => (
                        <div
                            key={idx}
                            className={`grid grid-cols-3 border-b border-[#f0f0f2] ${idx === rows.length - 1 ? "border-b-0" : ""
                                }`}
                        >
                            {/* Task */}
                            <div className="p-[16px] md:p-[20px] flex items-center">
                                <p className="font-semibold text-[13px] md:text-[14px] text-[#212326]">
                                    {item.task}
                                </p>
                            </div>

                            {/* Old way */}
                            <div className="p-[16px] md:p-[20px] bg-[#fafafa] border-x border-[#e4e5e7] flex items-center">
                                <p className="font-medium text-[12px] md:text-[13px] text-[#9298a0] leading-[1.5]">
                                    {item.old}
                                </p>
                            </div>

                            {/* New way */}
                            <div className="p-[16px] md:p-[20px] bg-[#fff8f5] flex items-center gap-[8px]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check w-[16px] h-[16px] text-[#2ecc71] shrink-0 hidden md:block">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="m9 12 2 2 4-4"></path>
                                </svg>
                                <p className="font-medium text-[12px] md:text-[13px] text-[#212326] leading-[1.5]">
                                    {item.new}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhySignetPrint;